// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"f1628ff2","453":"20359781","861":"5c634dbe"}[chunkId] + ".chunk.js";
};